<template>
  <div>
    <v-card class="mb-4">
      <v-card-title>
        {{ title }}
      </v-card-title>

      <apexchart type="pie"
                 v-if="!loading"
                 :options="chartOptions"
                 :series="series">
      </apexchart>
    </v-card>
  </div>
</template>
<script>
import convertBytesToHumanReadable from 'human-readable-bytes';
import { v4 as uuid } from 'uuid';

export default {
  props: {
    group: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    metric: {
      type: String,
      required: true,
    },
    metrics: {
      type: Array,
      required: true,
    },
    palette: {
      type: String,
      default: 'palette1',
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {text: 'Date', value: 'date',},
      ],
      showTable: false,
    }
  },
  computed: {
    series() {
      return this.metrics.map(m => parseInt(m[this.metric]));
    },
    chartOptions() {
      return {
        chart: {
          //group: this.group,
          width: 'auto',
          id: uuid(),
          type: 'pie',
        },
        labels: this.metrics.map(m => m.presentation_type),
        legend: {
          position: 'bottom',
        },
        theme: {
          palette: this.palette,
        },
        /*title: {
          text: this.title,
          align: 'left',
        },*/
        tooltip: {
          enabled: true,
          formatter: value => {
            return convertBytesToHumanReadable(value, 1024, 1, true);
          }
        }
      };
    },
  },
  created() {

  },
  methods: {}
}
</script>
